import { useRouter } from 'next/router';

export function useHomeUrl(locale?: string): string {
  const { defaultLocale, locale: routerLocale } = useRouter();
  const currentLocale = locale || routerLocale;

  return currentLocale === defaultLocale ? '/' : `/${currentLocale}/`;
}
